import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Currency } from '@/types';

const RATES: Record<Currency, number> = {
  AED: 1,
  THB: 9.4,
};

const SYMBOLS: Record<Currency, string> = {
  AED: 'AED ',
  THB: '฿',
};

interface CurrencyState {
  currency: Currency;
  setCurrency: (c: Currency) => void;
  format: (usdAmount: number) => string;
  convert: (usdAmount: number) => number;
}

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set, get) => ({
      currency: 'AED',
      setCurrency: (currency) => set({ currency }),
      convert: (usdAmount) => Math.round(usdAmount * RATES[get().currency] * 100) / 100,
      format: (usdAmount) => {
        const converted = get().convert(usdAmount);
        return `${SYMBOLS[get().currency]}${converted.toFixed(2)}`;
      },
    }),
    { name: 'aura-currency' }
  )
);
